export const validation = {
  question: "Question is required",
  validQuestion: "Please enter valid Question",
  typeOfFaqs: "Type Of faqs is required",
  answer: "Answer is required",
};
